import React from "react";
import { useTheme } from "../../context/ThemeContext";

/** Page loader: blue logo on light theme, white logo on dark (matches navbar). */
const Spinner = () => {
  const { theme } = useTheme();
  const base = process.env.PUBLIC_URL || "";
  const file = theme === "dark" ? "aw-white.png" : "aw-blue.png";
  const src = `${base}/${file}`;

  return (
    <div
      className="gf-page-loader"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <img
        className="gf-page-loader__logo"
        src={src}
        alt=""
        decoding="async"
      />
      <span className="gf-page-loader__sr">Loading…</span>
    </div>
  );
};

export default Spinner;
